import errorHandler from './utils/errorHandler';
import React, { useState } from 'react';
import { TextField, Button, List, ListItem, ListItemText, Typography, CircularProgress } from '@mui/material';
import api from './axiosConfig';

const SearchEmployee = ({ onEmployeeSelect }) => {
  const [query, setQuery] = useState('');
  const [employees, setEmployees] = useState([]);
  const [searchError, setSearchError] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const handleSearch = async () => {
    errorHandler.logDebug('SearchEmployee', 'Initiating search with query:', query);
    setIsSearching(true);
    try {
      const response = await api.get(`/reviews/search?query=${encodeURIComponent(query)}`);
      errorHandler.logDebug('SearchEmployee', 'Search response:', response.data);
      setEmployees(response.data);
      setSearchError(null);
    } catch (error) {
      console.error('Error searching employees:', error.response ? error.response.data : error.message);
      setSearchError(errorHandler.handleApiError(error, 'SearchEmployee.handleSearch'));
      setEmployees([]);
    } finally {
      setIsSearching(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSearch();
    }
  };

  return (
    <div>
      <TextField
        label="Search Employee"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        fullWidth
        margin="normal"
      />
      <Button variant="contained" onClick={handleSearch} disabled={isSearching}>
        {isSearching ? <CircularProgress size={20} /> : 'Search'}
      </Button>
      {searchError && <Typography color="error">{searchError}</Typography>}
      {employees.length === 0 && !searchError && !isSearching && query && (
        <Typography>No employees found. Try a different search term.</Typography>
      )}
      <List>
        {employees.map(emp => (
          <ListItem key={emp.id} button onClick={() => {
            // emp.id is the employee's secure_id (Employee.to_dict() maps
            // secure_id into the id field) — this is what every reviews
            // endpoint expects in the URL, no translation needed.
            errorHandler.logDebug('SearchEmployee', 'Employee selected from list:', emp.id);
            onEmployeeSelect(emp.id, emp.name);
          }}>
            <ListItemText primary={emp.name} secondary={emp.position || emp.job_role} />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default SearchEmployee;